import axios from 'axios';
import { PANELS_URL, CREATE_PANELS_URL } from '../../API/Api';

// Get All panels
const getAllPanels = async (token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'GET',
		baseURL: `${PANELS_URL}`,
		headers: headers,
	});
	return response.data;
};
//post all panels
const getSinglePanel = async (id, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'GET',
		baseURL: `${PANELS_URL}/${id}`,
		headers: headers,
	});
	return response.data;
};

//post all panels
const postAllPanels = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'POST',
		baseURL: `${PANELS_URL}/create`,
		headers: headers,
		data: data,
	});
	return response.data;
};

// post Search
const PanelsSearch = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'GET',
		baseURL: `${PANELS_URL}/search`,
		headers: headers,
		params: data,
	});
	return response.data;
};
//post all panels
const deletePanel = async (id, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'Delete',
		baseURL: `${PANELS_URL}/delete`,
		headers: headers,
		data: id,
	});

	return response.data.data.id;
};

//update Pane
const updatePanel = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'POST',
		baseURL: `${PANELS_URL}/edit`,
		headers: headers,
		data: data,
	});

	return response.data;
};
const panelsService = {
	getAllPanels,
	getSinglePanel,
	postAllPanels,
	deletePanel,
	updatePanel,
	PanelsSearch,
};

export default panelsService;
